// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__nav-bar',
    // #endregion
    // #region Computes
    computed: {
        mainMenuEntriesLeft() {
            return this.$host.store.getter("navigation/getMenu", "MAIN").filter(e => e.alignment == 0);
        },
        mainMenuEntriesRight() {
            return this.$host.store.getter("navigation/getMenu", "MAIN").filter(e => e.alignment == 1);
        },
    }
    // #endregion
});
// #endregion
